module.exports = __webpack_public_path__ + "static/media/scale_icon.62214fbe.svg";